class BundleBlock extends HTMLElement {
  constructor() {
    super()
    this.type = this.querySelector('.additional-product-block__products').dataset.type
    this.options = this.querySelectorAll('input')
    this.button = this.querySelector('.additional-product-block__button') ? this.querySelector('.additional-product-block__button') : this
    this.hasButton = this.querySelector('.additional-product-block__button') ? true : false
    this.selectedOptionElement = this.closest('.cto-upsell')?.querySelector('.cto-insurance__selected-option') ? this.closest('.cto-upsell').querySelector('.cto-insurance__selected-option') : false

    this.options.forEach(option => {
      option.addEventListener('change', this.handleChangeOption.bind(this))
    })

    if (this.hasButton) {
      this.button.addEventListener('click', this.handleATCButton.bind(this))
    }
    document.addEventListener('price:updated', this.updateMainPriceWithBundles.bind(this))
  }

  handleChangeOption(event) {
    event.preventDefault()
    let input = event.target
    if (this.type == 'one-option') {
      this.options.forEach(option => {
        if (option != input) {
          option.checked = false
        }
      })
    }
    if (this.selectedOptionElement) {
      this.selectedOptionElement.innerHTML = input.dataset.title
    }
    
    this.handleATCButton('check')
    // if (this.checkOptions() == false) {
    //   this.handleATCButton()
    // }
    if (this.checkOptions() && this.button.classList.contains('additional-product-block__button--added')){
      this.updateMainPriceWithBundles('change')
    }
  }

  handleATCButton(action) {
    let actionType = action == 'check' ? action : 'click'
    let productsSelected = this.checkOptions()
    let isChecked = this.button.classList.contains('additional-product-block__button--added')
    if (!isChecked && !productsSelected) return
    if (isChecked) {
      if (actionType == 'click' || productsSelected == false) {
        this.options.forEach(el => {
          el.checked = false
        })
        if (this.hasButton) {
          this.button.innerHTML = this.button.dataset.add
        }
        this.button.classList.remove('additional-product-block__button--added')
        this.updateMainPriceWithBundles('remove')
      }
    } else {
      if (this.hasButton) {
        this.button.innerHTML = this.button.dataset.added
      }
      this.button.classList.add('additional-product-block__button--added')
      this.updateMainPriceWithBundles('add')
    }
  }

  updateMainPriceWithBundles(operationType) {
    let priceToUpdate = Number(this.getSelectedOptionsPrice())
    let priceElements = document.querySelectorAll('.js-product-price-with-care-warranty')
    switch (operationType) {
      case 'remove':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') ? el.querySelector('.js-cto-dynamic-pricing span') : el.querySelector('.js-cto-dynamic-pricing')
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price - Number(this.dataset.addedPrice))   
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatPriceWithoutCurrency(price - Number(this.dataset.addedPrice))   
          }
        })
        this.dataset.addedPrice = ''
        if (this.selectedOptionElement) {
          this.selectedOptionElement.innerHTML = this.selectedOptionElement.dataset.default
        }
        break;
      case 'change':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') ? el.querySelector('.js-cto-dynamic-pricing span') : el.querySelector('.js-cto-dynamic-pricing')
          let price = this.formatMoney(priceEl.innerHTML)
          let oldPrice = price - Number(this.dataset.addedPrice)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(oldPrice + Number((priceToUpdate / 100).toFixed(2)))
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatPriceWithoutCurrency(oldPrice + Number((priceToUpdate / 100).toFixed(2)))
          }
        })
        this.dataset.addedPrice = Number((priceToUpdate / 100).toFixed(2))
        break;        
      case 'add':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') ? el.querySelector('.js-cto-dynamic-pricing span') : el.querySelector('.js-cto-dynamic-pricing')
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
          }
        })
        this.dataset.addedPrice = Number((priceToUpdate / 100).toFixed(2))
        break;
      default:
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') ? el.querySelector('.js-cto-dynamic-pricing span') : el.querySelector('.js-cto-dynamic-pricing')
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
          }
        })
        this.dataset.addedPrice = Number((priceToUpdate / 100).toFixed(2))
        break;
    }
    this.updateNMPPricing(operationType)
  }

  updateNMPPricing(operationType) {
    let priceElements = document.querySelectorAll('.js-product-price-with-care-warranty')
    let priceToUpdate = Number(this.getSelectedOptionsPrice()) / Number(priceElements[0].dataset.priceCalculation)
    switch (operationType) {
      case 'remove':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price - Number(this.dataset.addedNmpPrice))   
        })
        this.dataset.addedNmpPrice = ''
        break;
      case 'change':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let price = this.formatMoney(priceEl.innerHTML)
          let oldPrice = price - Number(this.dataset.addedNmpPrice)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(oldPrice + Number((priceToUpdate / 100).toFixed(2)))
        })
        this.dataset.addedNmpPrice = Number((priceToUpdate / 100).toFixed(2))
        break;        
      case 'add':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
        })
        this.dataset.addedNmpPrice = Number((priceToUpdate / 100).toFixed(2))
        break;
      default:
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
        })
        this.dataset.addedNmpPrice = Number((priceToUpdate / 100).toFixed(2))
        break;
    }
  }

  formatPriceWithoutCurrency(price) {
    const locale = 'en';
    const currency = 'MAD';

    const formattedPrice = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(price);
    return formattedPrice;
  }

  formatMoney(price) {
    if (typeof price === 'number') return price;
    const formattedMoney = price.replace(/[^0-9.-]+/g, '');
    return Number(formattedMoney);
  }

  getSelectedOptionsPrice() {
    let price = 0
    this.options.forEach(option => {
      if (option.checked) {
        price += Number(option.dataset.price)
      }
    })
    return price
  }

  checkOptions() {
    let result = false
    this.options.forEach(option => {
      if (option.checked){
        result = true
      }
    })
    return result
  }

  getProductsToAdd() {
    let productsArray = []
    this.options.forEach(option => {
      if (option.checked){
        let obj = {
          id: option.dataset.id,
          quantity: '1',
          properties: {'_uniq_id': String(Date.now() + Math.floor(Math.random() * 300)), '_is_upsell': true, '_item_key': Date.now() + Math.floor(Math.random() * 300)}
        }
        productsArray.push(obj)
      }
    })
    return productsArray.length != 0 ? productsArray : null
  }
}
customElements.define("bundle-block", BundleBlock);